import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { ImportPractitioner } from "../config/practitionerSliceAPi";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import SuccessModal from "components/wizard/StatusCheckStatusModal";
import ImportErrorModal from "./ImportErrorModal";

const UploadPracitionerModal = ({ show, onClose, payload }) => {
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorData, setErrorData] = useState({ title: '', errors: [] });
  const onConfirm = async () => {
    try {
      const response = await dispatch(ImportPractitioner(payload)).unwrap();
      if (response?.success) {
        setShowSuccessModal(true);
        onClose();
      } else {
        if (response?.data?.errors && response.data.errors.length > 0) {
          setErrorData({
            title: response.message_en || 'Import Error',
            errors: response.data.errors
          });
          setShowErrorModal(true);
          onClose();
        } else {
          toast.error(response?.message_en || 'Something went wrong');
        }
      }
    } catch (error) {
      if (error?.data?.errors && error.data.errors.length > 0) {
        setErrorData({
          title: error.message_en || 'Import Error',
          errors: error.data.errors
        });
        setShowErrorModal(true);
        onClose();
      } else {
        toast.error(error?.message_en || 'Something went wrong');
      }
    }
  };

  return (
    <>
      <Modal show={show} centered dialogClassName="wizard-modal">
        <Modal.Body>
          <FalconCloseButton
            onClick={onClose}
            size="sm"
            className="position-absolute top-0 end-0 me-2 mt-2"
          />
          <Flex direction="column" alignItems="center" className="mb-3">
            <h6 className="fs-9 text-700">Upload Practitioner</h6>
            <h6 className="fs-11 text-400 text-center">
              Do you Want to Upload the Practitioner ?
            </h6>
          </Flex>

          <hr />
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button variant="danger" size="sm" onClick={onClose}>
              No
            </Button>
            <Button variant="success" size="sm" onClick={onConfirm}>
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <SuccessModal
        modal={showSuccessModal}
        setModal={setShowSuccessModal}
        title="Successfully"
        description={"Practitioners Uploading Successfully"}
        pract={true}
      />
      <ImportErrorModal
        show={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title={errorData.title}
        errors={errorData.errors}
      />
    </>
  );
};

UploadPracitionerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default UploadPracitionerModal;
